import { render, staticRenderFns } from "./_base-hello-world.vue?vue&type=template&id=487dbc82&scoped=true&"
import script from "./_base-hello-world.vue?vue&type=script&lang=js&"
export * from "./_base-hello-world.vue?vue&type=script&lang=js&"
import style0 from "./_base-hello-world.vue?vue&type=style&index=0&id=487dbc82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487dbc82",
  null
  
)

export default component.exports